import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog';
import type { ConfirmDialogData } from '../../shared/interfaces';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private readonly dialog = inject(MatDialog);

  private readonly defaultConfig: MatDialogConfig = {
    width: '400px',
    disableClose: true,
  };

  confirm(data: ConfirmDialogData, config?: MatDialogConfig): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      ...this.defaultConfig,
      ...config,
      data,
    });

    return dialogRef.afterClosed().pipe(map(res => res ?? false));
  }
}
